
































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
  components: {},
})
export default class OnBoardingTour extends Vue {
  loading: boolean = true;
  showOnboarding = true;
  step: number = 1;

  get tourOptions() {
    return {
      useKeyboardNavigation: false,
      labels: {
        buttonSkip: this.$t('Skip tour'),
        buttonPrevious: 'Previous',
        buttonNext: 'Next',
        buttonStop: 'Finish',
      },
    };
  }

  get steps() {
    return [
      {
        target: '[data-v-tour="1"]',
        header: {
          title: 'Wochenkalender',
        },
        content: `Dies ist der Wochenkalender - hier können Sie via Klick einfach die Tage wechseln und über die Pfeile zwischen den Wochen navigieren.`,
        params: {highlight:false, placement:'right'}
      },
      {
        target: '[data-v-tour="2"]',
        header: {
          title: 'Zeiten erfassen',
        },
        content: `Dies ist der Wochenkalender - hier können Sie via Klick einfach die Tage wechseln und über die Pfeile zwischen den Wochen navigieren.`,
        params: {highlight:false, placement:'left'}
      },
      {
        target: '[data-v-tour="3"]',
        content: 'An awesome plugin made with Vue.js!',
        params: {highlight:true}
      },
      {
        target: '[data-v-tour="4"]',
        content: "Try it, you'll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.",
        params: {
          placement: 'top', // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ];
  }

  start() {
    this.$tours['myTour'].start();
  }

  mounted() {

  }
}
